export const ELOQUA_ACCOUNTS_PAGE_TITLE = 'Loading Eloqua Contacts';
export const ELOQUA_SUMMARY_LOAD_1 = 'Please wait for the contacts from your ';
export const ELOQUA_SUMMARY_LOAD_2 =
    ' Eloqua Account to load in order to do the matching with your segment';
